import { useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

/** @deprecated This hook is deprecated, pls use use-query-params instead */
export const useQueryParams = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const query = useMemo(() => new URLSearchParams(location.search), [location.search])

  const get = useCallback((key: string) => query.get(key), [query])

  const set = useCallback(
    (key: string, value: string) => {
      query.set(key, value)
      navigate(`${location.pathname}?${query.toString()}`)
    },
    [query, location.pathname, navigate],
  )

  const setSilently = useCallback(
    (key: string, value: string) => {
      query.set(key, value)
      window.history.replaceState({}, '', `${location.pathname}?${query.toString()}`)
    },
    [query, location.pathname],
  )

  const clear = useCallback(() => {
    query.forEach(key => query.delete(key))
    navigate(location.pathname)
  }, [query, location.pathname, navigate])

  const clearSilently = useCallback(() => {
    query.forEach(key => query.delete(key))
    window.history.replaceState({}, '', location.pathname)
  }, [query, location.pathname])

  const clearOneSilently = useCallback(
    (key: string) => {
      query.delete(key)

      const updatedSearch = query.toString()
      const newUrl = `${location.pathname}${updatedSearch ? `?${updatedSearch}` : ''}`

      window.history.replaceState({}, '', newUrl)
    },
    [query, location.pathname],
  )

  return { get, set, setSilently, clear, clearSilently, clearOneSilently }
}
